import { render, staticRenderFns } from "./EmpresaTabelaGestaoAlvorada.vue?vue&type=template&id=3e5e5803&lang=pug"
import script from "./EmpresaTabelaGestaoAlvorada.vue?vue&type=script&lang=js"
export * from "./EmpresaTabelaGestaoAlvorada.vue?vue&type=script&lang=js"
import style0 from "./EmpresaTabelaGestaoAlvorada.vue?vue&type=style&index=0&id=3e5e5803&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports